export default __webpack_public_path__ + "images/54c28b17676f4e857a9c5efdf8119420-holiday_touchpoint_image.webp";